module.exports = __webpack_public_path__ + "media/logo/white-on-black-wide-b20adf19.png";